module.exports = __webpack_public_path__ + "static/media/barque.74062642.svg";